// @flow
import {connect} from 'react-redux';

import {setVoucherDetailsComeFrom} from '../../../../modules/Voucher';
import VouchersFrame from './VouchersFrame';

const mapStateToProps = (state, ownProps) => ({
  comeFrom: ownProps.comeFrom,
  parentScreen: ownProps.parentScreen,
});

const mapDispatchToProps = dispatch => ({
  setVoucherDetailsComeFrom: (comeFrom: string) =>
    dispatch(setVoucherDetailsComeFrom(comeFrom)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VouchersFrame);
